import React from 'react';
import Icon from 'components/AppIcon';

const BulkActions = ({ selectedCount, onBulkCancel, onClearSelection }) => {
  return (
    <div className="bg-primary-50 border border-primary-100 rounded-trading p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-primary-100 rounded-trading flex items-center justify-center">
            <Icon name="CheckSquare" size={16} className="text-primary" />
          </div>
          <div>
            <p className="font-body-medium text-sm text-text-primary">
              {selectedCount} order{selectedCount !== 1 ? 's' : ''} selected
            </p>
            <p className="text-xs text-text-secondary">
              Choose an action to apply to selected orders
            </p>
          </div>
        </div>

        <div className="flex items-center space-x-3">
          <button
            onClick={onBulkCancel}
            className="flex items-center space-x-2 px-4 py-2 bg-error text-white rounded-trading hover:bg-red-700 transition-colors duration-trading-fast"
          >
            <Icon name="X" size={16} />
            <span className="font-body-medium text-sm">Cancel Selected</span>
          </button>
          
          <button
            onClick={onClearSelection}
            className="flex items-center space-x-2 px-4 py-2 bg-secondary-100 text-text-primary rounded-trading hover:bg-secondary-200 transition-colors duration-trading-fast"
          >
            <Icon name="Square" size={16} />
            <span className="font-body-medium text-sm">Clear Selection</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;